"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

require("./conditionalPaletteComponent.scss");

var authoring_common_1 = require("authoring-common");

var ColorUtil_1 = __importDefault(require("../../utils/ColorUtil"));

var ConditionalPaletteComponent =
/** @class */
function (_super) {
  __extends(ConditionalPaletteComponent, _super);

  function ConditionalPaletteComponent(props, state) {
    var _this = _super.call(this, props, state) || this;

    _this.state = {
      openPaletteDialog: false
    };
    return _this;
  }

  ConditionalPaletteComponent.prototype.componentDidMount = function () {
    var conditionalFormatModel = this.props.conditionalFormatModel;
    conditionalFormatModel.loadPalette();
  };

  ConditionalPaletteComponent.prototype.render = function () {
    var _this = this;

    var openPaletteDialog = this.state.openPaletteDialog;
    var _a = this.props,
        conditionalFormatModel = _a.conditionalFormatModel,
        uiContext = _a.uiContext;
    var palette = conditionalFormatModel.getPalette();
    var chevronRight16 = uiContext.getIcons().getIcon('common-chevron_right_16');
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column',
      className: 'vis-cf-conditionalPaletteContainer'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-paletteHeaderSection'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFromattingCurrentPalette'),
      className: 'vis-cf-conditionalPaletteLabel'
    }), react_1.default.createElement(ca_ui_toolkit_1.Button, {
      icon: uiContext.getIcons().getIcon('addNew'),
      iconSize: "small",
      variant: "icon",
      intent: "primary",
      title: StringResources_1.default.get('conditionalFromattingCreateNewPalette'),
      onClick: function onClick() {
        _this._showPaletteDialog(true);
      },
      className: 'vis-cf-conditionalPaletteAddPalette'
    }), openPaletteDialog && this._renderDialog()), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-paletteTop'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: palette.getLabel(),
      className: 'vis-cf-conditionalPaletteTheme'
    }), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-paletteContent'
    }, palette.getFills().map(function (color, index) {
      return react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
        className: 'vis-cf-paletteOption',
        style: color && ColorUtil_1.default.getColorStyle(color.color, color.fill || color, color.pattern),
        key: index,
        "datat-index": index,
        "data-value": color
      });
    }))), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-conditionalPalletChangePalleteWrapper'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      justifyContent: 'flex-end'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      width: '50%',
      className: 'vis-cf-conditionalPalletChangePallete'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      justifyContent: 'flex-end'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      className: 'vis-cf-changePaletteLabel',
      label: StringResources_1.default.get('conditionalFromattingChangePalette'),
      onClick: this._handleOnClick.bind(this)
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.SVGIcon, {
      size: 'small',
      className: 'svgIcon vis-cf-changePaletteIcon',
      verticalAlign: 'middle',
      iconId: chevronRight16.id,
      onClick: this._handleOnClick.bind(this)
    })))))));
  };
  /**
   * show/hide the custom palette dialog
   * @param show shows the palette dialog if true
   */


  ConditionalPaletteComponent.prototype._showPaletteDialog = function (show) {
    if (show === void 0) {
      show = true;
    }

    this.setState({
      openPaletteDialog: show
    });
  };

  ConditionalPaletteComponent.prototype._renderDialog = function () {
    var _this = this;

    var uiContext = this.props.uiContext;
    return react_1.default.createElement(authoring_common_1.CustomPalette, {
      key: 'createPalette',
      paletteService: uiContext.getPaletteService(),
      isDialogOpen: true,
      paletteType: 'ConditionalPalette',
      onPaletteCreated: this._onPaletteCreated.bind(this),
      removeDialog: function removeDialog() {
        return _this._showPaletteDialog(false);
      }
    });
  };

  ConditionalPaletteComponent.prototype._getPaletteId = function () {
    var conditionalFormatModel = this.props.conditionalFormatModel;
    return conditionalFormatModel.getPaletteId();
  };

  ConditionalPaletteComponent.prototype._onChangePalette = function (_propertyName, palette) {
    var conditionalFormatModel = this.props.conditionalFormatModel;
    conditionalFormatModel.setPaletteId(palette.id);
  };

  ConditionalPaletteComponent.prototype._onPaletteCreated = function (paletteId) {
    var prefixCMId = '__CM__';
    var cmId = prefixCMId + paletteId;
    var conditionalFormatModel = this.props.conditionalFormatModel;
    conditionalFormatModel.setPaletteId(cmId);
  };

  ConditionalPaletteComponent.prototype._handleOnClick = function () {
    var uiContext = this.props.uiContext;
    var options = {
      overlay: true,
      width: '300px',
      content: {
        module: 'authoring-common/changePaletteView',
        selectedId: this._getPaletteId(),
        onCreatePalette: this._onPaletteCreated.bind(this),
        createPaletteType: 'standard',
        name: 'condColorPalette',
        getPalettes: uiContext.getPalettes.bind(uiContext),
        getPaletteId: this._getPaletteId.bind(this),
        onChange: this._onChangePalette.bind(this),
        onRemove: uiContext.onCloseChangePaletteView.bind(uiContext),
        component: 'dashboard',
        panelId: 'childPalettePanel'
      }
    };
    uiContext.displayChildPanel(options);
  };

  return ConditionalPaletteComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(ConditionalPaletteComponent);
